import React, { useState, useEffect } from "react";
import RestService from "./RestService";
import GlobalHelmet from "./../../GlobalHelmet";
import Loader from "./../../component/Loader";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
import CommonBreadCum from "./CommonBreadCum";
import CustomTable from "./../../component/CustomTable";
import HIGHLOWFaqs from "./HIGHLOWFaqs";

export default function High52Data() {
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);

  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";

  useEffect(() => {
    setLoading(true);
    RestService.getMarketMovesData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data?.response);
        //console.log("globaldata", globaldata);
      },
      mobile,
      web_token,
      "52-week-high"
    );
  }, [mobile, web_token]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <GlobalHelmet {...Common?.high52} />
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs page="52 Week High" />
              {!globaldata ? <Loader /> : <></>}
            </div>
            <div className="col-sm-12">
              <h1>52 Week High</h1>
              <p>Get a list of 52 week high stocks and 52 week low stocks. Analyze previous 52 week high shares and 52 week low shares with many other parameters like previous high date, % Chg, change etc. Trading stocks which make daily high along with new 52 week highs are good for short term perspective and medium-term perspective. Trading stocks which are making daily new lows with new 52 week low are very risky stocks. One one knows, when daily falling stocks will stop falling. So avoid such stocks. Get a daily list of 52 week high shares and 52 week low share. Learn how to trade 52 week high nse and 52 week low nse stocks? </p>
            </div>
            <div className="col-sm-12">
              <CommonBreadCum />
            </div>
            <div className="col-sm-12">
              {!globaldata.getDetails ? (
                ""
              ) : (
                <>
                  <CustomTable
                    key={globaldata.setColumn.dataField}
                    columndata={
                      globaldata.setColumn ? globaldata.setColumn : ""
                    }
                    marketdata={
                      globaldata.getDetails ? globaldata.getDetails : ""
                    }
                    redirectlink="/stocks/"
                  />
                </>
              )}
            </div>
            <div className="col-sm-12 mt-4">
              <HIGHLOWFaqs getDetails={globaldata.getDetails} fiveExtData={globaldata?.fiveExtData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
